import { Record, List } from 'immutable';

export const SupplierRecord = new Record({
  s_id: '',
  company: '', 
  contact: '', 
  contacts: List([]),
  is_agreement: 1,
  contactphone: '', 
  on_line_contact: '',
  attachments: List([]),
  remark: '',
  key: 0,
  files: '',
  payment_account: '',
  destinations: List([]),
});

export const FileRecord = new Record({
  uid: '',
  name: '',
  status: 'done',
  url: '',
  thumbUrl: '',
  id: '',
});